{
  "Languages": {
    "SelectTitle": "Selecciona tu idioma",
    "Spanish": "Español",
    "English": "Inglés"
  },
  "NotFound": {
    "Code": "404",
    "Title": "Error",
    "Subtitle": "No pudimos encontrar la página que estabas buscando"
  },
  "Loading": "Cargando",
  "Header": {
    "MiCel": "Mi Cel",
    "Adelanto": "Adelanto",
    "Repatriation": "Repatriación",
    "AtmNetwork": "Red de cajeros automáticos",
    "Assistant": "Registro por Whatsapp",
    "HowItWorks": "¿Cómo funciona?",
    "WhySendola": "¿Por qué Sendola?",
    "ForPartners": "Sé un socio",
    "AboutUs": "Nosotros",
    "SendolaCorp": "Sendola Corp",
    "LoginButton": "Iniciar sesión",
    "SignupButton": "Registrarme",
    "Personal": "Personal",
    "Business": "Negocio"
  },
  "FloatingButton": {
    "Phone": "Llámanos",
    "Support": "Envíanos un whatsapp",
    "Faqs": "Preguntas frecuentes"
  },
  "Home": {
    "HeadingTitle": "<span>More Money.</span> No Borders.",
    "HeadingCallout": "La plataforma en EE.UU. para pagos globales de banco-a-banco",
    "SendMoney": "Accede a la Libertad Financiera: Conectando a las Comunidades Migrantes con Bancos y Pagos de Confianza",
    "SendMoneyDesktop": "Guarda, gasta y envía dinero globalmente, <b>a tu manera</b>",
    "LoginTitle": "¡Comienza ya!",
    "LoginSubtitle": "Ingresa tu número telefónico para iniciar sesión",
    "Or": "O",
    "LoginButton": "Iniciar sesión",
    "SignupButton": "Registrarme",
    "ScrollCallout": "Envía dinero a",
    "CountriesWeService": "Países a los que enviamos",
    "Video": "<span>Estamos cambiando</span> la forma de enviar dinero.",
    "BankAccount": {
      "Title": "¿Necesitas una cuenta de banco?",
      "Subtitle": "Abre una ahora con un Socio Sendola",
      "Button": "Encuentra un banco"
    },
    "CountriesSection": {
      "Title": "El mundo es más pequeño con",
      "Subtitle": "Envía tu apoyo en pesos o euros con la misma confianza de siempre.",
      "Countries": "países",
      "NewDestinations": "nuevos destinos",
      "Button": "¡Registrarme ahora!",
      "Disclaimer": "Disponible en Mayo 2025. Argentina a partir del 30 de mayo."
    },
    "Section1": {
      "Title": "Buscando las mejores condiciones en USA"
    },
    "Section2": {
      "Title": "Una forma flexible y global de usar tu dinero",
      "Subtitle": "Tú eliges cómo, a dónde y cuándo enviar tu dinero."
    },
    "Section3": {
      "Title": "Beneficios",
      "Subtitle": "¡En Sendola, trabajamos cada día para ofrecerte más beneficios!",
      "ImageAlt": "Persona con celular",
      "LogoAlt": "Beneficios",
      "Bullet1": {
        "Title": "Adelantos de nómina",
        "Paragraph": "Solicita un adelanto de tu depósito directo cuando lo necesites.",
        "Button": "Descubre Adelanto"
      },
      "Bullet2": {
        "Title": "Comprar un teléfono de gama alta",
        "Paragraph": "Adquiere el teléfono que deseas con pagos cómodos y flexibles.",
        "Button": "Comprar Mi Cel"
      },
      "Bullet3": {
        "Title": "Repatriación completa y sin complicaciones",
        "Paragraph": "Tranquilidad total, incluso en los momentos más difíciles.",
        "Button": "Descubre Contigo"
      }
    },
    "Section4": {
      "Title": "Lo que nuestros clientes dicen:"
    },
    "Testimonial1": {
      "Name": "Anthony Gerardo Tovar",
      "Ocupation": "Martori Farms, Águila, Arizona",
      "Content": "Una herramienta muy útil para los trabajadores que venimos con la meta de salir adelante. La atención que brindan es excelente en todo momento."
    },
    "Testimonial2": {
      "Name": "Renée Triay",
      "Ocupation": "CEO Glam2Go",
      "Content": "Vivo entre México y EE. UU. desde hace 20 años, y las transferencias de dinero siempre fueron un problema. Ahora, con Sendola, puedo enviar dinero a México usando Zelle por solo $4.99. ¡Finalmente es fácil, conveniente y accesible!"
    },
    "Testimonial3": {
      "Name": "Mariana Cuervo",
      "Ocupation": "Profesionista Colombiana",
      "Content": "Sendola me ha permitido acceder a servicios que anteriormente me fueron negados o que eran muy complicados de contratar. Ahora, todo es mucho más accesible."
    },
    "Modal": {
      "title": "Crea tu cuenta de forma rápida y sencilla",
      "singUpButton": "Registrarme ahora",
      "or": "o",
      "whatsappButton": "Prefiero registrarme por WhatsApp",
      "back": "Regresar",
      "hi": "¡Hola!"
    }
  },
  "Countries": {
    "MX": "México",
    "IN": "India",
    "GT": "Guatemala",
    "PH": "Filipinas",
    "CN": "China",
    "DO": "República Dominicana",
    "VN": "Vietnam",
    "SV": "El Salvador",
    "HN": "Honduras",
    "NI": "Nicaragua",
    "CA": "Canadá",
    "PA": "Panamá",
    "NG": "Nigeria",
    "CO": "Colombia",
    "BR": "Brasil",
    "AR": "Argentina",
    "CL": "Chile",
    "PL": "Polonia",
    "PT": "Portugal",
    "America": "América",
    "Asia": "Asia",
    "Europe": "Europa",
    "Other": "Otros corredores"
  },
  "Banners": {
    "AmericaGreat": "<span>Para los que hacen</span> de EE.UU. un gran país.",
    "NewCountries": {
      "Title": "Nuevos destinos,",
      "Title2": "mismos beneficios",
      "Subtitle": "Ahora puedes enviar pesos a LATAM y euros a Europa con Sendola Pay.",
      "Button": "Conoce más",
      "Disclaimer": "*Argentina a partir del 30 de mayo"
    }
  },
  "Quoter": {
    "Amount": "¿Cuánto deseas enviar?",
    "Receive": "Tu beneficiario recibirá",
    "Account": "Depósito a cuenta",
    "Cash": "Retiro de efectivo",
    "ExchangeRate": "Tipo de cambio",
    "Fee": "Tarifa de transferencia",
    "PaymentMethodFee": "Tarifa:",
    "D2BPlaceholder": "Elige un banco",
    "CPUPlaceholder": "Elige un punto de retiro",
    "NoD2BDestination": "El país seleccionado no permite depósito a cuenta.",
    "NoCPUDestination": "El país seleccionado no permite retiro de efectivo.",
    "Button": "Enviar dinero",
    "Disclaimer": "*Los comercios e instituciones varian según el destino elegido.",
    "Disclaimer2": "Esta cotización puede variar según el destino y método de pago.",
    "Disclaimer3": "Los precios y tipos de cambio son solo de referencia y pueden variar según las condiciones del mercado, el país de destino, el método de pago y otros factores. Sendola no garantiza los tipos de cambio mostrados.",
    "Disclaimer4": "Los tipos de cambio, comisiones y demás información de precios proporcionados tienen únicamente fines informativos y no constituyen una oferta final, cotización ni acuerdo vinculante.",
    "DisclaimerViewMore": "Leer más.",
    "DisclaimerExtended": "<b>Aviso legal: Uso informativo únicamente</b><br><br>Los tipos de cambio, comisiones y demás información de precios proporcionados por el cotizador de tarifas en el sitio web de Sendola tienen únicamente fines informativos y no constituyen una oferta final, cotización ni acuerdo vinculante. Los términos reales de la transacción—incluyendo tipos de cambio, comisiones por servicio y montos totales a pagar—pueden variar según el país de destino, el método de pago, el monto de la operación, las fluctuaciones del mercado y los requisitos regulatorios. <br><br>Todos los datos sobre tarifas provienen de Uniteller Inc. y están sujetos a cambios sin previo aviso. Sendola no garantiza la precisión, integridad ni disponibilidad en tiempo real de la información mostrada. <br><br>El usuario es responsable de revisar y confirmar los términos finales antes de iniciar cualquier transacción. Para obtener precios definitivos y las divulgaciones requeridas conforme a las leyes federales y estatales de transmisión de dinero, incluyendo las establecidas por la <b>Regla de Remesas del CFPB (12 CFR § 1005.30 y ss.),</b> continúe al proceso de confirmación o comuníquese con nuestro equipo de atención al cliente. ",
    "DeliveryMethod": {
      "Title": "Método de entrega",
      "NotAvailable": "No disponible para este destino"
    },
    "Channel": {
      "Title": "Elige la mejor oferta para ti",
      "BestFx": "Mejor FX",
      "CheaperFee": "Sin comisión",
      "NotAvailable": "Oferta no disponible actualmente"
    },
    "PaymentMethod": {
      "Title": "Método de pago",
      "Placeholder": "Elige una opción",
      "Zelle": "Zelle®",
      "Venmo": "Venmo®",
      "PayPal": "PayPal®",
      "Sendola ACH": "Tu cuenta bancaria (ACH)"
    },
    "PaymentMethodDesktop": {
      "Zelle": "Zelle®",
      "Venmo": "Venmo®",
      "PayPal": "PayPal®",
      "Sendola ACH": "ACH"
    },
    "Time": {
      "Zelle": "En minutos",
      "Venmo": "Mismo día",
      "PayPal": "En minutos",
      "Sendola ACH": "1-3 días"
    },
    "Total": {
      "Send": "Monto a enviar",
      "Fee": "Tarifa total",
      "TransactionFee": "Tarifa de transferencia",
      "PaymentMethodFee": "Tarifa de método de pago",
      "Total": "Pago total"
    }
  },
  "Cards": {
    "Card1": {
      "Title": "Con tu tarjeta o cuenta de banco",
      "Paragraph": "Envía dinero directo a casa desde tu banco."
    },
    "Card2": {
      "Title": "O solicita una cuenta con tu banco",
      "Paragraph": "Te ayudamos a solicitar una cuenta con uno de los bancos disponibles en tu estado dentro de USA:",
      "Bullet1": "Obtén una cuenta y una tarjeta de débito sin historial crediticio.",
      "Bullet2": "Vincúlate con Plaid para enviar dinero al extranjero fácilmente."
    },
    "Card3": {
      "Title": "Tú eliges cómo pagar:",
      "Paragraph": "Elige tu método de pago"
    },
    "Card4": {
      "Title": "Adquiere tu teléfono ideal a plazos",
      "Paragraph": "Obtén el teléfono que deseas con pagos <b>cómodos y flexibles</b>, adaptados a tus necesidades."
    }
  },
  "Partners": {
    "Title": "Nuestra red y socios de confianza",
    "Disclaimer": "Sendola está debidamente autorizada y registrada como Transmisor de Dinero en el Estado de Arizona y está registrada para operar en el Estado de Montana. Proporcionamos cobertura de pagos P2P, C2B y B2B en los 50 estados de EE. UU. como agente autorizado de nuestros socios estratégicos, incluyendo Uniteller, More Payments y Uniteller Money Desk. Para Ascendant, servimos como corredor comercial para servicios B2B en EE. UU. SentSprint se unirá pronto a nuestra red.<br><br>Para operaciones de pago internacionales, trabajamos con socios líderes como Tesored en México, Appriza Pay en México y América Latina, y GYT Continental en Guatemala. Esta sólida red garantiza los más altos estándares de cumplimiento para transacciones transfronterizas seguras y eficientes.<br><br>Todas las transacciones están sujetas a los términos y condiciones de nuestros socios y a las regulaciones aplicables en cada jurisdicción."
  },
  "Footer": {
    "Address1": "Sendola Corp.",
    "Address2": "6710 E. Camelback Rd",
    "Address3": "Scottsdale, AZ 85253",
    "Phone": "Tel:",
    "PhoneNumber": "+1 (520) 342-0520",
    "ReportIssue": "Reportar un problema o soporte:",
    "SupportEmail": "support@sendola.io",
    "Email": "Correo:",
    "ContactEmail": "contact@sendola.io",
    "Disclaimer": "Sendola cuenta con la debida licencia y registro como transmisor de dinero en el estado de Arizona y está autorizada para operar en el estado de Montana. Ofrecemos servicios de pagos P2P, C2B, B2B y B2C en los 50 estados de EE.UU. como agente autorizado de nuestros socios estratégicos, incluidos <a class='text-blue-600' href='http://www.uniteller.com/state-licensing'>Uniteller Inc.</a>, More (una división de Uniteller) y Uniteller Money Desk.",
    "Disclaimer2": "Para pagos internacionales, colaboramos con socios líderes como Tesored en México, Appriza Pay en México y América Latina, y GYT Continental en Guatemala. Esta sólida red garantiza transacciones transfronterizas seguras, eficientes y plenamente conformes con las regulaciones.",
    "Disclaimer3": "Todas las transacciones se realizan bajo los términos y condiciones de nuestros socios y en cumplimiento de las normativas aplicables en cada jurisdicción.",
    "UnitellerDisclaimer": "UniTeller | International Money Transfer & Payment Processing Services<br>State Licensing | UniTeller<br>State Licensing State License Number ALASKA 10013 ALABAMA SOC# 556 ARKANSAS 41717 ARIZONA MT-0903157 CALIFORNIA 1947 COLORADO 50121 CONNECTICUT MT-928684 DELAWARE 6583 DISTRICT OF COLUMBIA MTR928684 FLORIDA 051740 GEORGIA 18891 HAWAII HIMT015 IOWA MT-2002-0135 IDAHO 054 ILLINOIS MT - 154 INDIANA 6742 KANSAS 0020001 KENTUCKY SC383800 LOUISIANA 214 MAINE Number Not Issued MASSACHUSETTS FT928684 MARYLAND",
    "LegalInformation": "Información legal",
    "AtmNetwork": "Red de cajeros",
    "CardProgram": "Sendola Card Program",
    "About": "¿Por qué Sendola?",
    "SendolaNMLS": "Sendola NMLS ID - 2508481"
  },
  "Advancement": {
    "title": "Accede hasta un 50% de adelanto de tu depósito directo cuando lo necesites.",
    "section1": {
      "title": "Tú decides en que gastarlo",
      "bullet1": "Envía dinero a casa de forma anticipada ",
      "bullet2": "Compra y paga productos y servicios",
      "bullet3": "Para emergencias e imprevistos"
    },
    "section2": {
      "title": "Elige cuánto quieres adelantar",
      "fee": "Cuota de adelanto",
      "usd": "dólares",
      "subtitle": "Hasta 7 días antes de recibir tu depósito directo",
      "info": "*Al contratar este servicio, la cuota o cuotas generadas se cobrarán el día de tu siguiente pago. El monto máximo que puedes adelantar es del 50% del total de tu pago de nómina. El plan se puede ejecutar solo en días hábiles.",
      "doubts": "Tengo más dudas sobre el servicio",
      "supportBtn": "Contactar soporte",
      "item1": "Hasta 25% de tu depósito directo",
      "item2": "Hasta 35% de tu depósito directo",
      "item3": "Hasta 50% de tu depósito directo"
    },
    "doubts": "Tengo más dudas sobre el servicio",
    "supportBtn": "Contactar soporte",
    "info": "Sin interés. Sin revisión crediticia.",
    "titleForm": "Llena el formulario para solicitar tu adelanto",
    "form": {
      "name": "Nombre",
      "phone": "Teléfono (Whatsapp)",
      "lastName": "Apellido",
      "company": "¿En qué empresa trabajas?",
      "contract": "¿Cuándo termina tu contrato con la empresa?",
      "infoAdvancement": "*Monto máximo a solicitar: $1,000 USD",
      "advancement": "¿Cuánto dinero quieres adelantar?",
      "money": "¿Para qué quieres usar el dinero?",
      "infoMoney": "*Esto nos ayuda a conocerte mejor",
      "button": "Solicitar adelanto"
    },
    "terms": "<b>Lea atentamente y firme en consecuencia.</b> Reconozco que he leído los Términos y condiciones y acepto estar sujeto a todos los términos, condiciones, reglas y regulaciones establecidos o incorporados por referencia en este documento. Conserve una copia de este documento firmado para sus registros.",
    "termsLink": "Términos y Condiciones"
  },
  "AtmNetwork": {
    "MainTitle": "Nuestra Red Asociada de Cajeros Automáticos",
    "MainSubtitle": "Más de 100,000 cajeros a tu alcance",
    "SecondaryTitle": "Encuentra el Cajero Automático más cercano a ti",
    "SecondarySubtitle": "Retira tu dinero en cualquier cajero automático de está Red.",
    "Callout": "Da click en la red que más te convenga y encuentra el cajero más cercano a ti",
    "Disclaimer": "*Sendola y USI FCU no cobran por usar la red CO-OP; sin embargo, las cooperativas de crédito tienen el derecho de cobrar una tarifa. El sistema cobra una tarifa de conveniencia de $1.00."
  },
  "Legal": {
    "Title": "Información legal",
    "Address": "Sendola Corp. 3040, Post Oak Blvd. Floor 18 Houston, TX, U.S.A.",
    "Bullet1": "Términos y condiciones de servicio",
    "Bullet2": "Política de privacidad",
    "Bullet3": "Política de conservación de datos",
    "Bullet4": "Política de seguridad de la información",
    "Bullet5": "Acuerdo de divulgación y comunicaciones electrónicas",
    "Bullet6": "Aviso sobre la Ley USA PATRIOT",
    "Bullet7": "Declaración de accesibilidad",
    "TermsLink": "https://s3.us-west-1.amazonaws.com/sendola.io/Disclosures+y+Legales+/Sendola.io/espa%C3%B1ol/Sendola+Terms+of+Service+ESP+(09032024)+PCD.pdf"
  },
  "Repatriation":{
    "title": "<b>Planes de asistencia</b> <br/> que se adaptan a ti, No al revés.",
    "section1": {
      "title": "Haz que cada momento cuente Contigo* un servicio que te respalda aún cuando no estes",
      "bullet1": "Repatriación ",
      "bullet2": "Logística",
      "bullet3": "Gestión"
    },
    "section2": {
      "title": "Elige el plan que mejor te acomode",
      "item1": {
        "name" : "Individual",
        "title" : "Titular de la membresía",
        "subtitle": "(Sin restricciones de edad o causa de muerte)",
        "first" : "Incluido con tu cuenta Sendola por enviar $500 USD o más al mes a tu país. ",
        "second" : "Recolección del cuerpo",
        "third": "Arreglo estético del cuerpo", 
        "fourth": "Ataúd Metálico",
        "fifth": "Sala de velación",
        "sixth": "Gestión de trámites",
        "seventh": "Asesoría jurídica testamentaria vía telefónica",
        "eighth": "Asistencia tanatológica",
        "footer": "*Servicio incluido enviando dinero al extranjero con un monto igual o mayor a 500 USD al mes."
      }, 
      "item2": {
        "name" : "Familiar",
        "title" : "Titular del plan, cónyuge e hijos",
        "subtitle": "(Sin restricciones de edad o cantidad de hijos)",
        "first" : "Recolección del cuerpo",
        "second" : "Arreglo estético del cuerpo  ",
        "third": "Ataúd Metálico ", 
        "fourth": "Sala de velación ",
        "fifth": "Gestión de trámites ",
        "sixth": "Asesoría jurídica testamentaria vía telefónica",
        "seventh": "Asistencia tanatológica ",
        "price": "Precio: 1.99 USD",
        "footer": "*Al contratar este servicio, el pago mensual se cobrará de forma automática."
      },
      "item3": {
        "name" : "Solo Padres",
        "title" : "Solo padres",
        "first" : "Recolección del cuerpo",
        "second" : "Arreglo estético del cuerpo  ",
        "third": "Ataúd Metálico ", 
        "fourth": "Sala de velación ",
        "fifth": "Gestión de trámites ",
        "sixth": "Asesoría jurídica testamentaria vía telefónica",
        "seventh": "Asistencia tanatológica ",
        "price": "Price: 1.99 USD",
        "footer": "*La adquisición del plan \"solo padres\" está limitada a titulares menores de 35 años; aquellos de 35 años o más no podrán contratar este plan."
      }
    },
    "doubts": "Conoce qué necesitas saber para recibir asistencia funeraria",
    "supportBtn": "Quiero asistencia",
    "info": "Llena el siguiente formulario para contratar tu servicio",
    "titleForm": "Activa tu plan",
    "form": {
      "name": "Nombre",
      "phone": "Teléfono (Whatsapp)",
      "lastName": "Apellido",
      "company": "¿En qué empresa trabajas?",
      "contract": "¿Cuándo termina tu contrato con la empresa?",
      "plan": "Elige tu plan",
      "check": "Al ingresar este formulario aceptas que tu información es verídica y se comenzará a hacer el cargo mensualmente a tu cuenta Sendola.",
      "button": "Contratar",
      "service": "Este servicio es brindado por ASOCIACIÓN NECROLÓGICA MEXICANA, S.A. DE C.V.",
      "familyPlan":  "Plan familiar",
      "onlyParentsPlan": "Plan solo padres"

    },
    "terms": "<b>Lea atentamente y firme en consecuencia.</b> Reconozco que he leído los Términos y condiciones y acepto estar sujeto a todos los términos, condiciones, reglas y regulaciones establecidos o incorporados por referencia en este documento. Conserve una copia de este documento firmado para sus registros.",
    "termsLink": "Términos y Condiciones",
    "sinister": "Siniestros",
    "sinisterSubtitle": "En caso de siniestro, para asistencia funeraria directa con el proveedor (ASOCIACIÓN NECROLÓGICA MEXICANA, S.A. DE C.V.)",
    "phone1": "Lada sin costo:",
    "phone2": "Llama desde México:",
    "sendEmail": "Envíanos un email",
    "visitFaqs": "Visita nuestras preguntas frecuentes",
    "customerService": "Servicio a cliente"
  },
  "MyPhone": {
    "title": "Conseguir el celular de tus sueños puede salir caro, <b>por eso es mejor pedirlo a plazos.</b>",
    "section1": {
      "title": "Tu mejor aliado es tener tu depósito directo para poder <b>adquirir tu nuevo celular</b>",
      "bullet1": "Configura tu depósito directo",
      "bullet2": "Ordena tu celular llenando el formulario",
      "bullet3": "Recibe tu nuevo celular"
    },
    "section2": {
      "title": "Elige tu mejor opción",
      "subtitle":"Presiona en el nombre de cada modelo para ver más detalles:",
      "labelPaymentPlan": "Ejemplo de plan de pagos:",
      "weeklyPayment": "Pago semanal:",
      "usd": "dólares",
      "term": "Plazo:",
      "weeks": "semanas",
      "total": "Precio total:",
      "shipping": "Costo de envío incluído.",
      "estimated": "Tiempo estimado de entrega: 7 días hábiles.",
      "pricesTerms": "Precio y plazos sujetos a cambio sin previo aviso y sobre entrega de cotización.",
      "availability": "Sujeto a disponibilidad del artículo.",
      "getPhone": "Lo quiero",
      "anotherPhone": "Si no has encontrado un celular que te guste, indícanos cuál te gustaría cotizar.",
      "quotePhone": "Cotizar otro celular",
      "infoBenefit": "Un beneficio exclusivo al contar con *depósito directo de tu nómina en tu cuenta Sendola.",
      "step1": "Elige un modelo",
      "step2": "Llena el formulario en nuestra página web",
      "step3": "Recibe tu propuesta para adquirir tu celular a plazos",
      "step4": "Firma la propuesta y espera recibir tu celular",
      "infoDirectDeposit": "*Registra tú nómina con tu cuenta Sendola para disfrutar este beneficio."
    },
    "section3": {
      "banner": "Llena el siguiente formulario para <b>pre-ordenar tu nuevo celular:</b>",
      "titleForm": "¿De dónde nos conocemos?",
      "name": "Nombre(s)",
      "surname": "Apellido(s)",
      "whatsapp": "Número de Whatsapp",
      "work": "¿Dónde trabajas?",
      "chooseCompany": "Elige una empresa",
      "endContract": "¿Cuándo termina tu contrato con la empresa?",
      "selectDate": "Selecciona una fecha",
      "subtitleForm": "Elige tu producto:",
      "product": "¿Qué producto quieres?",
      "model": "Elige una marca y modelo:",
      "modelPlaceholder": "Elige una opción",
      "quote": "Quiero cotizar otra marca y modelo:",
      "quotePlaceholder": "Escribe aquí la marca y modelo",
      "quoteTerms": "Al llenar este formulario, aceptas nuestros Términos y Condiciones y preordenas el producto elegido. Nuestro equipo se pondrá en contacto contigo para más detalles.",
      "buttonPreOrder": "Pre-ordenar",
      "termsAndConditions": "Términos y Condiciones",
      "productOption1": "Celular + SIM (chip)",
      "productOption2": "Solo Celular",
      "productOption3": "Solo SIM (chip)",
      "selectSmartphone": "Selecciona"
    }
  },
  "Faqs": {
    "title": "Preguntas frecuentes",
    "message": "¡Gracias por elegir Sendola! Entendemos que puede tener preguntas sobre nuestros productos y servicios, políticas y más. Para que su experiencia sea perfecta, hemos compilado una lista de preguntas frecuentes para brindarle respuestas rápidas e informativas.",
    "chooseCategory": "Elige una categoría",
    "search": "¿Qué estás buscando?",
    "ariaSearch": "Introducir texto para filtrar preguntas",
    "noFound": "Lo lamentamos, no pudimos encontrar ningún resultado que coincida con tu criterio de búsqueda. Por favor, vuelve a intentarlo con diferentes palabras claves.",
    "category": {
      "tab1": {
        "title": "Conoce Sendola",
        "item1": {
          "title": "¿Qué es Sendola?",
          "text": "Sendola Corp es una empresa de tecnología financiera y no una cooperativa de crédito asegurada por la NCUA (Administración Nacional de Cooperativas de Crédito). Nuestras oficinas físicas están ubicadas en Houston, Texas, y Ciudad de México, México."
        },
        "item2": {
          "title": "¿Cuánto tiempo tarda una transacción en completarse?",
          "text": "El tiempo de cambio depende del tipo de transferencia (directo a cuentas de banco o para retirar en ventanilla). <br/><br/>Sin embargo, aquí te podemos decir que EN PROMEDIO:<br/><br/><b>MÉXICO:</b><br/>De lunes a viernes las transferencias D2B a México tardan entre 20 y 30 minutos en pagarse. Los fines de semana y festivos pueden tardar hasta 2 horas.<br/>Las transferencias de CPU a Bancoppel o Financiera del Bienestar tardan alrededor de 10 minutos en estar disponibles para que el usuario las recoja.<br/>El resto de los destinos de CPU están disponibles a los 30 minutos de su envío.<br/><br/><b>GUATEMALA:</b><br/>Las transferencias D2B a Banco G&T se pagan en promedio en 40 minutos, a otros bancos pueden demorar hasta 2 horas.<br/>Las transferencias de CPU están disponibles 30 minutos después de su envío."
        },
        "item3": {
          "title": "¿Qué medidas de seguridad utilizan para proteger mis datos?",
          "text": "En Sendola, tu seguridad es nuestra prioridad. Implementamos varias medidas para asegurarnos de que tus datos estén siempre protegidos:",
          "point1": "Restricción del acceso a los datos",
          "point2": "Cifrado de datos (encriptación)",
          "point3": "Implementación de políticas de confidencialidad y retención de datos",
          "point4": "Programas de ciberseguridad",
          "point5": "Medidas de seguridad físicas",
          "point6": "Acuerdos de confidencialidad"
        },
        "item4": {
          "title": "¿Cuáles son las tarifas por envío?",
          "text": "El tipo de cambio varía dependiendo de:",
          "point1": "País de destino",
          "point2": "Tipo de transferencia (D2B o CPU)",
          "point3": "Banco o institución donde se recoge la CPU",
          "point4": "Cantidad enviada",
          "text2": "Así como las condiciones del 'mercado'. El tipo de cambio del mercado cambia cada minuto. Actualizamos el tipo de cambio diariamente."
        },
        "item5": {
          "title": "¿Puedo enviar dinero a cualquier país?",
          "text": "Puedes enviar dinero a cuentas bancarias o retirar dinero en efectivo en: México, Guatemala, Argentina, Bolivia, Brasil, Chile, Colombia, Perú, Panamá y Uruguay."
        }
      },
      "tab2": {
        "title": "¿Vuelves a tu país?",
        "item1": {
          "title": "¿Necesito activar mi tarjeta para uso fuera de Estados Unidos?",
          "text": "Sí, manda un mensaje solicitando la activación de tu tarjeta para uso en el extranjero, así no tendrás complicaciones al querer pagar en establecimientos o hacer retiros."
        },
        "item2": {
          "title": "¿Activaste Sendola con un teléfono de Estados Unidos que ya no vas a tener en tu país?",
          "text": "Si actualmente cuentas con número de celular que vas a usar en tu país puedes hacer el cambio antes de salir de Estados Unidos. Si aún no tienes el número celular de tu país, nos puedes contactar cuando estés en México o Guatemala para hacer el cambio de número. En cualquier caso, llama a nuestro centro de servicio o manda un mensaje por WhatsApp donde validaremos tu identidad y te apoyaremos con el cambio."
        },
        "item3": {
          "title": "¿Podré contar con el dinero de mi cuenta Sendola en mi país?",
          "text": "Por supuesto que Sí. El dinero en tu cuenta es tuyo y puedes tener acceso a él donde estés. Hay 3 maneras para que puedas disponerlo en México/Guatemala:",
          "point1": "Usando el servicio de envío de dinero de Sendola, puedes hacer envíos a tu cuenta de banco de tu país.",
          "point2": "<b>Sacando dinero del cajero automático (ATM).</b> Podrás sacar tu dinero en cualquier cajero automático en tu país que acepte VISA. Los montos y comisiones de los cajeros en México o Guatemala dependen de la institución dueña del cajero automático (promedio $3 dólares). Tu tarjeta USI-Sendola te cobrará $1 dólar por cada retiro.",
          "point3": "<b>Pagando directamente con tu tarjeta Sendola en cualquier establecimiento que acepte VISA.</b> Esta opción estará disponible siempre y cuando cuentes con dinero en tu cuenta. La comisión por uso de tu tarjeta USI-Sendola en establecimientos es de un 1% del monto total de la compra."
        }
      },
      "tab3": {
        "title": "Pagos globales",
        "item1": {
          "title": "¿Qué es Sendola Global payments?",
          "text": "Es la solución de Sendola para personas que quieren enviar dinero desde Estados Unidos a otros países."
        },
        "item2": {
          "title": "¿A qué países puedo enviar dinero?",
          "text": "En Global Payments puedes enviar dinero a México, Guatemala, Honduras, El Salvador, Colombia, Bolivia, Ecuador, Perú, Uruguay, Brasil, Argentina y Chile; seguimos trabajando para llegar cada día a más países."
        },
        "item3": {
          "title": "¿Por qué requiero compartir la ubicación de mi dispositivo?",
          "text": "Por temas de cumplimiento legal es muy importante que compartas tu ubicación."
        },
        "item4": {
          "title": "¿Puedo enviar dinero si rechazo compartir la ubicación de mi dispositivo?",
          "text": "Si No compartes la ubicación de tu dispositivo, No podrás realizar Envíos de Dinero.<br/><br/>Puedes compartir la ubicación de tu dispositivo entrando a la opción de Ajustes de tu Teléfono en la opción Ubicación – Activar Ubicación."
        },
        "item5": {
          "title": "Si rechazo por equivocación compartir la ubicación de mi dispositivo, ¿cómo puedo compartir la ubicación para poder enviar dinero?",
          "text": "Puedes compartir la ubicación de tu dispositivo entrando a la opción de Ajustes de tu Teléfono en la opción Ubicación – Activar Ubicación."
        },
        "item6": {
          "title": "¿Desde qué lugares tengo permitido realizar Envíos de Dinero?",
          "text": "Puedes realizar Envíos de Dinero desde cualquier estado de los Estados Unidos de América. Afuera de los Estados Unidos No puedes realizar Envíos de Dinero."
        },
        "item7": {
          "title": "¿Con qué documentos puedo realizar mi validación de identidad en el proceso de alta?",
          "text": "Los documentos con los cuales puedes realizar tu validación de identidad son:",
          "point1": "México: INE y Pasaporte",
          "point2": "Guatemala: DPI - Documento Personal de Identificación y Pasaporte",
          "point3": "Estados Unidos: Visa, Permiso de Residencia, Licencia de Conducir o Número de Seguro Social"
        },
        "item8": {
          "title": "¿Cómo me informan que ya completé mi proceso de alta para que pueda realizar mis envíos de dinero?",
          "text": "Recibirás un correo electrónico informándote que tu proceso de validación ha sido aprobado o al ingresar al servicio de Global Payments recibirás un mensaje de aprobación."
        },
        "item9": {
          "title": "¿Qué es un método de pago y qué métodos de pago tengo para enviar dinero?",
          "text": "El método de pago es el origen de los recursos para realizar el Envío de Dinero. Los métodos de pago disponibles para enviar dinero son Sendola Pay y ACH (Uso de Fondos de una cuenta bancaria externa)."
        },
        "item10": {
          "title": "¿Qué es Sendola Pay?",
          "text": "Sendola Pay es el uso de la cuenta Sendola One para realizar envíos de dinero."
        },
        "item11": {
          "title": "¿Si no tengo Sendola One, puedo realizar envíos de dinero?",
          "text": "Sí, puedes realizar envíos de dinero utilizando una cuenta bancaria estadounidense para realizar tus Envíos de Dinero."
        },
        "item12": {
          "title": "¿En qué consiste el método de pago de ACH (Uso de Fondos de una cuenta bancaria externa)?",
          "text": "Consiste en utilizar una cuenta bancaria estadounidense para realizar tus Envíos de Dinero."
        },
        "item13": {
          "title": "¿Cuál es el importe máximo en una transacción de envío de dinero utilizando Sendola Pay o ACH (Uso de Fondos de una cuenta bancaria externa)?",
          "text": "El importe máximo en una transacción de Envío de Dinero utilizando Sendola Pay o ACH (Uso de Fondos de una cuenta bancaria estadounidense) es de $1,500 USD."
        },
        "item14": {
          "title": "¿Cuántas transacciones puedo realizar diaria y mensualmente?",
          "text": "Puedes realizar hasta 3 transacciones diarias utilizando tu Sendola Pay o 6 Transacciones diarias usando ACH (Uso de Fondos de una cuenta bancaria externa). Mensualmente puedes realizar hasta 12 transacciones en Sendola Pay o ACH (Uso de Fondos de una cuenta bancaria estadounidense)."
        },
        "item15": {
          "title": "¿Qué es un método de entrega y que métodos de entrega tengo para enviar dinero?",
          "text": "El método de entrega son las opciones que tienes para enviar dinero y los métodos de entrega que tenemos disponibles son",
          "point1": "Depósito a cuenta",
          "point2": "Cobro en ventanilla"
        },
        "item16": {
          "title": "¿Puedo enviar dinero si mi Beneficiario no tiene una cuenta bancaria?",
          "text": "Sí, puedes enviar dinero aun y cuando tu beneficiario no tenga cuenta bancaria, con el método de envío de Cobro en ventanilla."
        },
        "item17": {
          "title": "¿Qué información requiero para realizar el alta de mi beneficiario de pago en el esquema Depósito a cuenta?",
          "text": "La información solicitada del Beneficiario en el esquema de Depósito a cuenta es: Para envíos de dinero a México, requieres la Clabe Bancaria. Para envíos de dinero a Guatemala, requieres el Número de cuenta de G&T. La información personal solicitada del Beneficiario es: Nombre completo, alias (opcional), Fecha de nacimiento, Dirección completa, Número de Teléfono y Correo electrónico."
        },
        "item18": {
          "title": "¿Qué información requiero para realizar el alta mi beneficiario de pago en el esquema Cobro en Ventanilla?",
          "text": "La información solicitada del Beneficiario en el esquema de Cobro en Ventanilla es: Nombre completo, alias (opcional), Fecha de nacimiento, Dirección completa, Número de Teléfono y Correo electrónico."
        },
        "item19": {
          "title": "Para México, ¿a qué Bancos puedo realizar mi Pago en el esquema de Depósito a Cuenta?",
          "text": "El envío de dinero en el esquema de Depósito a Cuenta se puede enviar a cualquier Clabe - Cuenta Bancaria del Sistema Financiero Mexicano."
        },
        "item20": {
          "title": "Para México ¿en qué Instituciones Pagadoras puedo enviar mi Pago para Cobro en Ventanilla?",
          "text": "En México puedes enviar el pago para Cobro en ventanilla a Bancoppel, Chedraui, Financiera para el Bienestar, Libertad Servicios Financieros y Waldos."
        },
        "item21": {
          "title": "¿En qué sucursal de las Instituciones Pagadoras puede mi Beneficiario cobrar en ventanilla?",
          "text": "¿En qué sucursal de las Instituciones Pagadoras puede mi Beneficiario cobrar en ventanilla?"
        },
        "item22": {
          "title": "¿Cómo puedo saber que el dinero ya ha sido entregado a mi Beneficiario?",
          "text": "Al cobrar en ventanilla, tanto tu como el beneficiario recibirán una notificación por correo."
        },
        "item23": {
          "title": "Para Guatemala ¿a qué Bancos puedo realizar mi Pago en el esquema de Depósito a Cuenta?",
          "text": "El banco disponible para envíos de dinero a Guatemala en el esquema Depósito a Cuenta es G&T."
        },
        "item24": {
          "title": "Para Guatemala ¿en qué Instituciones Pagadoras puedo recibir mi Pago para Cobro en Ventanilla?",
          "text": "En Guatemala puedes enviar el pago para Cobro en ventanilla a G&T."
        },
        "item25": {
          "title": "¿Cómo puedo consultar el recibo de mi operación?",
          "text": "El recibo de tu operación se puede descargar de la pantalla del comprobante y del correo del comprobante de la operación."
        },
        "item26": {
          "title": "¿Qué información se requiere para cobrar en ventanilla mi pago recibido?",
          "text": "La información requerida para cobrar en ventanilla el pago recibido es el 1) Número de Control de la Transferencia de Dinero (MTCN), 2) Nombre del procesador de la transacción (Appriza, Tesored o G&T) y 3) Presentar una identificación oficial del país donde se realiza el cobro del Envío de dinero."
        },
        "item27": {
          "title": "¿Cómo me puedo comunicar a Servicio a Cliente de Sendola?",
          "text": "En Sendola estamos para responder cualquier pregunta que tengas, en el teléfono 832-730-2683, por correo <a target='_blank' href='mailto:support@sendola.io' rel='noopener' class='text-fuchsia-400'>support@sendola.io</a> o escribiéndonos en la opción de Contáctatenos que se encuentra en el pie de la página de Global Payments."
        }
      },
      "tab4": {
        "title": "Sendola One",
        "item1": {
          "title": "¿Qué es Sendola One?",
          "text": "Sendola One es una plataforma con los mayores estándares de seguridad que te permite tener una cuenta de cheques y ahorros con USI Federal Credit Union, <span class='italic'>(miembro NCUA)</spanA y una tarjeta Internacional (Visa) para que puedas contar con tu dinero disponible cuando tú lo necesites. En esta tarjeta podrás disponer de tu dinero en efectivo para retirar en la red de cajeros automáticos CO-OP,  recibir tu nómina, tener ahorros, recibir y hacer pagos como acceder automáticamente a todos los beneficios que tenemos para ti. "
        },
        "item2": {
          "title": "¿Cuáles son los beneficios de Sendola One?",
          "text": "Sendola One te permite contar con beneficios como",
          "point1": "a. Recibir el pago de tu nómina.",
          "point2": "b. Recibir fondos u otros pagos directamente en tu tarjeta vía ACH.",
          "point3": "c. Puedes pagar servicios con tu Sendola One como compra de saldo o envío de dinero al extranjero con Sendola Global Payments.",
          "point4": "d. Tu tarjeta tiene respaldo Visa (R) por lo que funciona en cualquier país."
        },
        "item3": {
          "title": "¿Cómo puedo acceder a los beneficios de Sendola One?",
          "text": "Es muy sencillo, solo completa tu registro y verifica tu identidad en la WebApp de SendolaOne y podrás acceder a una cuenta virtual y en pocos días recibirás tu tarjeta fisica en tu domicilio."
        },
        "item4": {
          "title": "¿Qué tipo de compras puedo realizar con mi Tarjeta Sendola?",
          "text": "Puedes utilizar tu tarjeta para compras en cualquier establecimiento que acepte Visa (R); también puedes realizar compras en línea en cualquier página web y disponer de efectivo en la red de cajeros ATM. Tanto en Estados Unidos, como en cualquier parte del mundo."
        }
      }
    }
  },
  "PendingRequest": {
    "title": "Hemos recibido tu solicitud",
    "subtitle": "Nuestro equipo está revisando tu petición y te contactará por <b class='text-green-500'>Whatsapp</b> a la brevedad",
    "btnAction": "Cerrar"
  },
  "BannerBank": {
    "title": "Sendola en alianza con Banner Bank te ofrecen: <strong>Cuenta personal de cheques</strong>",
    "subtitle": "Banner Bank es una gran opción para ti",
    "text": "Descubre por qué es la mejor opción para manejar tu dinero en Estados Unidos.",
    "section1": {
      "bullet1": "Tarjeta de Débito Mastercard aceptada en todo el mundo.",
      "bullet2": "Banca en línea desde tu dispositivo favorito.",
      "bullet3": "Configura pagos recurrentes con tu tarjeta de débito.",
      "bullet4": "Protección antifraude y Cero Responsabilidad (Mastercard Zero Liability Protection).",
      "bullet5": "<a href='https://locations.bannerbank.com/search' class='underline' target='_blank'>Red de cajeros en todo el país</a>",
      "terms": "Términos y condiciones"
    },
    "section2": {
      "title": "Conecta tu cuenta con Sendola",
      "subtitle": "Si ya tienes una cuenta Banner Bank, conéctala con tu cuenta Sendola de forma rápida y segura a través de Plaid y <b>¡recibe más beneficios!</b>",
      "bullet1": "$25.00 USD de regalo de apertura de cuenta.",
      "bullet2": "Recibe tu nómina en tu cuenta vía depósito directo.",
      "bullet3": "Reembolso de tarifa en envíos de + $1,000 USD con Zelle en Sendola si usas Banner Bank.",
      "bullet4": "Todos los beneficios de ser usuario Sendola:",
      "button": "¡Conócelos!"
    },
    "buttonConnect": "Ya tengo cuenta, conectar ahora",
    "section3": {
      "title": "Abre tu cuenta Banner Bank",
      "subtitle": "Obtén tu tarjeta de forma sencilla:",
      "request": "Solicítala en",
      "request2": "diferentes ubicaciones",
      "location1": {
        "title": "Tortilleria Santa Fe",
        "point1": "Con asistencia del equipo Sendola.",
        "point2": "Royal City, Washington.",
        "point3": "Todos los viernes de 12 p.m. PT a 5 p.m. PT.",
        "textLink": "Ver dirección"
      },
      "location2": {
        "title": "Sucursales Banner Bank",
        "point1": "Yakima",
        "point2": "Sunnyside",
        "point3": "Hermiston",
        "washington": ", Washington",
        "oregon": ", Oregon"
      }
    }
  },
  "Errors": {
    "fieldRequired": "Este campo es requerido"
  },
  "WhySendola": {
    "Heading": "¿Por qué Sendola?",
    "Promise": "Nuestra Promesa",
    "Mision": "Misión y Valores",
    "Cards": {
      "Card1": {
        "Title": "Tarifas bajas:",
        "Paragraph": "Se acabaron los días de aprovecharse de los inmigrantes. ¿Nuestras tarifas? Las más bajas que podemos conseguir gracias a la red bancaria Sendola."
      },
      "Card2": {
        "Title": "Entrega a tiempo:",
        "Paragraph": "Tu dinero cuando lo necesitas. Rápido, confiable y siempre a tiempo o te reembolsamos las tarifas."
      },
      "Card3": {
        "Title": "Paga a tu manera:",
        "Paragraph": "Nosotros creemos en la libertad de pago. Cuantas más formas de pagar tengas, más libre serás; esa es nuestra promesa, siempre."
      },
      "Card4": {
        "Title": "Seguro y protegido:",
        "Paragraph": "Duerme tranquilo. Somos como una bóveda que mantiene tu dinero seguro y protegido gracias a los estrictos estándares de nuestra red bancaria Sendola."
      }
    },
    "MessageFromCeo": {
      "Title": "Mensaje del CEO",
      "Content": "Como <span>fundador y CEO de Sendola,</span> me enorgullece enormemente presentarles una <span>plataforma</span> en la que la <span>integridad, la seguridad y la inclusión</span> impulsan todo lo que hacemos. Sendola es más que una empresa de pagos; somos un </span>facilitador que une</span> las brechas entre continentes y culturas."
    },
    "BankingBanner": "“Creemos que la banca es <span>libertad</span><span>”</span>",
    "Texts": {
      "Card1": {
        "Paragraph1": "Si tus servicios financieros no son económicos o accesibles <span><span>- no eres libre.</span></span>",
        "Paragraph2": "Si te ves obligado a utilizar efectivo porque no puedes obtener una tarjeta de débito y una cuenta de cheques <span>- no eres libre.</span>",
        "Paragraph3": "Si no puedes mover tu dinero fácilmente para apoyar a tus familiares o celebrar el cumpleaños de un tío al otro lado del mundo <span>- no eres libre.</span>"
      },
      "Card2": {
        "Paragraph1": "<span>Ningún inmigrante</span> en Estados Unidos debería estar sujeto a un sistema bancario diferente.",
        "Paragraph2": "Nuestro impacto no es para unos pocos sino para muchos: los millones de inmigrantes hispanos, indios y asiáticos que buscan el <span>Sueño Americano.</span>",
        "Paragraph3": "Ya sea que estés aquí con una <span>visa patrocinada por tu empleador</span> o como un <span>migrante recién llegado</span>, mereces la misma oportunidad de ahorrar, gastar y enviar dinero que todos los demás.",
        "Paragraph4": "Es por eso que nos esforzamos por ofrecer un servicio que acorte la brecha entre el <span>acceso financiero en los EE. UU.</span> y las familias que esperan al otro lado del mundo."
      },
      "Card3": {
        "Title": "Nuestro enfoque es distinto",
        "Paragraph1": "No solo por nuestros valores o nuestra misión de disolver las fronteras en las transacciones financieras, sino porque <span>nos integramos perfectamente con los sistemas bancarios</span> en los que ya confías. En Sendola, creemos que la banca asequible es un derecho fundamental. Nuestro enfoque incansable en la seguridad y la confianza es evidente en el diseño de nuestra plataforma; somos un servicio y una plataforma que cree que para conectar verdaderamente al mundo, debemos integrarnos con el mundo, no hacer que el mundo se integre con nosotros.",
        "Paragraph2": "Concebida como el <span>“Zelle de los pagos globales”,</span> Sendola revoluciona la forma en que los titulares de cuentas en bancos y miembros de cooperativas de crédito de todo el país administran sus finanzas. Nuestra plataforma trasciende las barreras tradicionales, haciendo que ahorrar, gastar y enviar dinero a nivel mundial sea lo más fácil, accesible y asequible posible. <span>La libertad en los servicios financieros no se trata de la cantidad de aplicaciones en tu teléfono, sino de la simplicidad y asequibilidad de esos servicios.</span>",
        "Paragraph3": "Nuestro futuro y nuestra promesa están definidos por la libertad de pago, <span>asegurada por tasas asequibles y la seguridad inquebrantable del sistema bancario de los Estados Unidos.</span> Con Sendola, la libertad financiera no es un privilegio: es un derecho accesible a todos, que une mundos y acerca a las personas.",
        "Paragraph4": "Juntos, redefinamos el panorama de los servicios financieros y garanticemos que cada individuo trabajador en los EE. UU. tenga la oportunidad de disfrutar de la libertad de pago tal como fue concebida: <span>sin límites. Esto es Sendola.</span>",
        "Signature1": "Abrazo fuerte,",
        "Signature2": "Enrique Huesca",
        "Signature3": "Un Fundador y CEO muy agradecido"
      }
    }
  },
  "HowItWorks": {
    "Heading": "Cómo funciona",
    "Section1": {
      "Title": "Cómo unirse a Sendola",
      "Step1": {
        "Title": "Crea tu cuenta",
        "Paragraph": "¡No se necesita identificación para registrarse! Abre tu cuenta con tu nombre completo, fecha de nacimiento y número de teléfono"
      },
      "Step2": {
        "Title": "Conecta tu banco con Plaid o agrega tu tarjeta",
        "Paragraph": "Con nuestro socio, Plaid, puedes conectar tu cuenta bancaria en unos pocos y sencillos pasos para disfrutar de una experiencia bancaria perfecta."
      }
    },
    "Section2": {
      "Title": "Cómo enviar dinero con Sendola",
      "Step1": {
        "Title": "Cotiza tu pago",
        "Paragraph": "Agrega la cantidad que deseas enviar, elige el país de destino y tu método de pago."
      },
      "Step2": {
        "Title": "Añade tu destinatario y guárdalo",
        "Paragraph": "Introduce el nombre y la dirección de la persona a la que quieres enviar dinero. ¡Pero no olvides guardarlo!"
      },
      "Step3": {
        "Title": "Elije tu preferencia de pago",
        "Paragraph": "Elije la velocidad de tu pago seleccionando nuestra opción “Express - En minutos” pagando a través de Zelle, o la opción “Economy - Mismo día” al pagar a través de Venmo, o la opción “Economy - 1-4 días hábiles” al pagar a través de ACH."
      }
    },
    "Section3": {
      "Title": "Cómo enviar con Zelle",
      "Subtitle": "¡Nuestra forma preferida de enviar dinero rápidamente!"
    }
  },
  "ForPartners": {
    "Heading": "Sé un socio",
    "Button": "Contáctanos",
    "Section1": {
      "Title": "¿Qué es Sendola?",
      "Subtitle": "Conectando <span>comunidades migrantes</span> a Banca y pagos confiables"
    },
    "Section2": {
      "Title": "Oportunidad de <span>Mercado Nacional</span>",
      "ImmigrantsCount": "45,300,000",
      "ImmigrantsText": "Inmigrantes",
      "ForeignCount": "22,500,000",
      "ForeignText": "Nacidos en el extranjero de países donde existe Sendola",
      "RemittancesCount": "$210 mil millones",
      "RemittancesText": "Remesas enviadas desde Estados Unidos en 2021"
    },
    "Section3": {
      "Title": "¿Por qué conectar con Sendola?",
      "Subtitle": "Sendola: Conectándote con los principales destinos de pago desde Estados Unidos ($Millones)",
      "OtherCountries": "Otros países donde prestamos servicios",
      "Disclaimer1": "KNOMAD/World Bank Bilateral Remittance Matrix 2021, Diciembre 2022.",
      "Disclaimer2": "Para México: Banxico, Estructura de Información de Remesas (año completo, 2023).",
      "Disclaimer3": "*Países que estarán disponibles próximamente en el servicio de Pagos Globales de Sendola."
    },
    "Section4": {
      "Title": "¿Por qué asociarse con Sendola?",
      "Subtitle": "Una solución financiera segura para cualquier inmigrante. Sin importar su historia.",
      "Zelle": "Somos el <b>Zelle</b> de los <span>Pagos Globales</span>",
      "Cards": {
        "Card1": {
          "Title": "Expande tu negocio",
          "Content": "Atiende de manera segura a los millones de profesionales que envían pagos transfronterizos."
        },
        "Card2": {
          "Title": "Ve más lejos",
          "Content": "Ofrece más que solo servicios financieros tradicionales. Cierra el ciclo para los migrantes profesionales que envían dinero al extranjero."
        },
        "Card3": {
          "Title": "Acceso a la red de cajeros automáticos",
          "Content": "Nuestra amplia red de cajeros automáticos garantiza que los usuarios puedan acceder a operaciones bancarias incluso en áreas remotas."
        },
        "Card4": {
          "Title": "Presencia y confianza",
          "Content": "Construye relaciones a largo plazo al ofrecer servicios valiosos a esta comunidad."
        }
      }
    },
    "Section5": {
      "Title": "¿Quién confía en Sendola?",
      "Subtitle": "Socios Bancarios y Cooperativas de Crédito",
      "Paragraph": "Nuestros socios bancarios y cooperativas de crédito reconocen los desafíos significativos en la ampliación de las oportunidades financieras para los migrantes profesionales en Estados Unidos. Con la confianza en Sendola, han ampliado sus servicios a pequeñas comunidades con soluciones bancarias que se adaptan a las necesidades locales.",
      "Locations": "Ubicaciones estatales",
      "Title2": "<span>Facilitando la intimidación</span> <br>de acercarse a grandes instituciones financieras:",
      "Subtitle2": "<b>La alianza entre Sendola y los bancos</b> ofrece a cada cliente la posibilidad de un:",
      "You": "Tú",
      "Together": "Juntos",
      "Icons": {
        "Icon1": "Cuenta de cheques",
        "Icon2": "Tarjeta de débito",
        "Icon3": "Pagos globales",
        "Icon4": "Comunidades de migrantes profesionales",
        "Icon5": "Siguiente nivel de comunicación",
        "Icon6": "Banca en línea integrada"
      }
    },
    "Section6": {
      "Title": "Nuestra red de cajeros automáticos",
      "Subtitle": "<span>\"El efectivo aún puede ser el rey\"</span>",
      "Points": {
        "Point1": {
          "Title": "Cerrando el ciclo",
          "Content": "Disfruta de una red extendida de cajeros automáticos colocados para servir a titulares de cuentas rurales y enfocados en el cliente."
        },
        "Point2": {
          "Title": "Incentivos de tarifas",
          "Content": "Lo único que pedimos es que nuestra asociación sirva a nuestros clientes. Ofrece incentivos en cajeros automáticos para abrir cuentas con depósito directo."
        },
        "Point3": {
          "Title": "Inclusividad financiera",
          "Content": "La ubicación de los cajeros automáticos es clave para cumplir nuestros compromisos de servir a nuestra comunidad con poco acceso bancario."
        },
        "Point4": {
          "Title": "El efectivo sigue siendo el rey",
          "Content": "Los usuarios de Sendola dependen de su capacidad para retirar efectivo. Nuestra red de cajeros automáticos resuelve ese problema para ellos."
        },
        "Point5": {
          "Title": "Sirve sin el trabajo",
          "Content": "Nuestros cajeros automáticos se gestionan de manera diferente. Ubicaciones remotas. Reposiciones frecuentes. <b>Deja que nosotros hagamos el trabajo.</b>"
        },
        "Point6": {
          "Title": "Cerrando la brecha",
          "Content": "Nuestra red de cajeros automáticos está creciendo. Ayúdanos a expandirnos para servir a más de tus clientes. Nosotros seguiremos haciendo el trabajo."
        }
      },
      "CostToYou": "Costo para ti:",
      "Cost": "$0.00",
      "Network": "Nuestra red es tu red",
      "Steps": {
        "Step1": {
          "Title": "¡Solo pregunta!",
          "Content": "Pregúntanos cómo podemos comenzar a servir a tus clientes actuales y futuros, así como a los titulares de cuentas. ¡Servimos a nivel nacional!"
        },
        "Step2": {
          "Title": "Incentivos en cajeros automáticos",
          "Content": "Nuestra red de cajeros automáticos está creciendo. Ayúdanos a expandirnos para servir a más de tus clientes. Nosotros seguiremos haciendo el trabajo."
        },
        "Step3": {
          "Title": "La red de Sendola",
          "Slashed": "Nuestra",
          "Content": "Nuestra asociación ofrece una red de cajeros automáticos y un proceso rápido de colocación para nuestros clientes y tus titulares de cuentas."
        }
      }
    },
    "Section7": {
      "Title": "Puntos clave",
      "Points": {
        "Point1": "Nuestro tipo de usuario realiza 5 veces más transacciones en promedio que un usuario regular",
        "Point2": "Bajas tarifas para comunidades desatendidas",
        "Point3": "Hasta 2 reembolsos de tarifas con socios bancarios de Sendola",
        "Point4": "Acceso a ubicaciones con alta demanda y desatendidas",
        "Point5": "Disponible en Washington, Oregón, California, Arizona, Texas y Colorado",
        "Point6": "y más ubicaciones <b>próximamente...</b>"
      }
    },
    "Section8": {
      "Title": "Seguridad y Cumplimiento Normativo",
      "Paragraph": "Sendola recopila información KYC del titular de la cuenta, el remitente y el destinatario de cada transacción procesada por Sendola Global Payments, comparable con la recopilación más completa del mercado para reducir el riesgo regulatorio y aumentar la seguridad de las transacciones.",
      "Card1": {
        "Title": "KYC del Usuario",
        "Content": "Recopilamos información personal y de identidad del titular de la cuenta que inicia la transacción con la ayuda de su institución."
      },
      "Card2": {
        "Title": "KYC del Beneficiario",
        "Content": "Recopilamos información de los beneficiarios para cumplir con los estándares KYC para cuentas N2, N3 y N4."
      },
      "Card3": {
        "Title": "OFAC y PEPs",
        "Content": "Monitoreo de transacciones para la Oficina de Control de Activos Extranjeros y Listas de Personas Políticamente Expuestas."
      },
      "Card4": {
        "Title": "Validación de listas negras",
        "Content": "Usuario validado contra más de 100 listas negras basadas en nuestros socios de seguridad y redes de pago."
      },
      "Card5": {
        "Title": "Uso de la cuenta",
        "Content": "Recopilamos datos de ubicación (coordenadas) cuando el usuario envía dinero."
      },
      "Card6": {
        "Title": "Almacenamiento de datos",
        "Content": "Almacenamiento de datos hasta 10 años en Estados Unidos y otros países (según lo exija la normativa)."
      },
      "Card7": {
        "Title": "Límites de transacción",
        "Content": "Se imponen “límites de velocidad” de originación para mejorar la seguridad."
      },
      "Card8": {
        "Title": "Límites por canal",
        "Content": "El nivel de escrutinio estará determinado por el tamaño del envío y el método de entrega."
      }
    },
    "Section9": {
      "Title": "Únete a nuestra red bancaria",
      "Subtitle": "Agenda una llamada con nuestro equipo",
      "Button": "Contáctanos"
    }
  },
  "AboutUs": {
    "Heading": "Nuestro Equipo",
    "Subtitle1": "Construyendo un mundo donde los ",
    "Subtitle2": "pagos globales sean para todos.",
    "LeadershipSection": "Liderazgo Estratégico",
    "Leadership1": {
      "name": "Enrique Huesca",
      "position": "CEO (Director Ejecutivo)"
    },
    "Leadership2": {
      "name": "Daniel Huerta",
      "position": "Director de SendolaPay - Negocio"
    },
    "Leadership3": {
      "name": "Paola Cortés",
      "position": "Director Legal Corporativo"
    },
    "Leadership4": {
      "name": "Edgar Herrera",
      "position": "Director de SendolaPay - Personal"
    },
    "Leadership5": {
      "name": "Eduardo Rivera",
      "position": "Director de Finanzas"
    },
    "LeadersSection": "Líderes Ejecutivos",
    "Leader1": {
      "name": "María José Huesca",
      "position": "Desarrollo de Relaciones Empresariales"
    },
    "Leader2": {
      "name": "Salvador Rochin",
      "position": "Director de Operaciones - Negocio"
    },
    "Leader3": {
      "name": "Gustavo Herrera",
      "position": "Director de Producto y tecnología"
    },
    "Leader4": {
      "name": "",
      "position": "Director de Ingeniería"
    },
    "Leader5": {
      "name": "Alejandro Creel",
      "position": "Director de Diseño"
    },
    "Leader6": {
      "name": "Perla Alvarado",
      "position": "Directora de Crecimiento"
    },
    "Leader7": {
      "name": "Marlia Alarcón",
      "position": "Gerente de Proyectos"
    },
    "Leader8": {
      "name": "Mariana Cuervo",
      "position": "Directora de Control Financiero"
    },
    "Leader9": {
      "name": "Boomer Carr",
      "position": "Director de Operaciones de Ventas y Experiencia del Cliente"
    },
    "Leader10": {
      "name": "Israel Sosa",
      "position": "Director de Operaciones - Personal"
    },
    "Leader11": {
      "name": "Renee Triay",
      "position": "Director de Ventas"
    },
    "Leader12": {
      "name": "Ilse Murillo",
      "position": "Redes de Negocio y Soporte a Concierge"
    },
    "Leader13": {
      "name": "Juan David Gómez",
      "position": "Director de Inteligencia de Negocio"
    }
  },
  "SendolaBlack": {
    "Title": "Unlock Global Success with Our Premium Payments Service",
    "Section1": {
      "Title": "Streamline Your Transactions, Maximize Your Savings",
      "Paragraph1": "Our <b>premium global payments service</b> offers high-level clients an unparalleled opportunity to enhance the <b>efficiency</b> of their large transactions while <b>saving</b> significantly <b>on costs.</b>",
      "Paragraph2": "Discover how our service stands apart from traditional banking options, such as international wires, and why <b>it's time to elevate your payment processes.</b>"
    },
    "Section2": {
      "Title": "Bank-grade security protocols to protect your transactions"
    },
    "Section3": {
      "Title": "Why Choose Us?",
      "Subtitle": "Freedom to move money seamlessly across the globe",
      "Card1": {
        "Title": "Cost-Effective Solutions",
        "Paragraph1": "<b>Reduce transaction fees and spreads,</b> cutting your costs significantly compared to traditional banking.",
        "Paragraph2": "<b>Enjoy clear pricing</b> that helps you save on every transaction."
      },
      "Card2": {
        "Title": "Global Reach",
        "Paragraph1": "Our service allows you to <b>seamlessly send money to Mexico</b> with other destination countries coming soon, <b>simplifying your operations</b> and empowering you to capitalize on new opportunities."
      },
      "Card3": {
        "Title": "Dedicated Support",
        "Paragraph1": "<b>A tailored service with a concierge experience</b> that simplifies your life, supported by a dedicated team who understands the intricacies of global payments and is committed to your success"
      }
    },
    "Section4": {
      "Title": "Skip the bank wires— connect with your counterparties internationally with just a few clicks, all backed by premium concierge support."
    },
    "Section5": {
      "Title": "Office Hours Premium Support",
      "Subtitle": "Contact Methods",
      "Method1": "Email Support",
      "Method2": "Phone Support",
      "Method3": "Live Chat"
    },
    "Section6": {
      "Quote": "Leave the fees behind, and embrace the adventure of living",
      "Title1": "Join the Movement",
      "Paragraph1": "Don't let traditional banking methods hold you back from achieving your business goals.",
      "Paragraph2": "<b>Sign up for our premium global payments</b> service today and experience the difference in <b>cost, efficiency, and security.</b> Transform the way you transact globally and take your business to new heights.",
      "Title2": "Get Started",
      "Paragraph3": "<b>Are you ready to transform borderless-banking transactions together?</b>",
      "Paragraph4": "Contact us now to learn more about our service and how we can help you <b>save money on large transactions</b> while providing unrivaled financial solutions for you.",
      "Button": "Apply today"
    },
    "Section7": {
      "Title": "How It Works:<br>Send Money in 3 Easy Steps",
      "Card1": {
        "Title": "Complete the Application Form",
        "Content": "Begin by filling out the Sendola Black application form online at www.sendola.io This simple form gathers key information to initiate the approval process for our Sendola Black service."
      },
      "Card2": {
        "Title": "Concierge Review",
        "Content": "Your application will be reviewed based on the information provided. The Sendola Black Concierge team will contact you via phone to finalize the application process."
      },
      "Card3": {
        "Title": "Send Premium Payments",
        "Content": "Once approved, you can immediately begin sending funds through the Sendola Black concierge team, ensuring seamless, secure transactions."
      },
      "Button": "Apply today"
    },
    "Section8": {
      "Title": "Cost Breakdown Table",
      "Subtitle": "Sending $10,000.00 to Mexico",
      "SavingsTitle": "*Savings for sending $10,000.00 USD with us:",
      "OtherBanks": "Other banks details",
      "FX": "FX Spread",
      "MXN": "MXN",
      "Card": {
        "Title": "Cost Breakdown Table",
        "Subtitle": "Sending $10,000.00 to Mexico",
        "Total": "Total Received:",
        "Card1": {
          "Name": "Other Banking Solutions",
          "Percentage": "3.2%",
          "Rate": "FX Rate $18.75*",
          "TotalAmount": "$184,523.88"
        },
        "Card2": {
          "Name": "",
          "Percentage": "1.5%",
          "Rate": "FX Rate $19.08*",
          "TotalAmount": "$190,758.05",
          "YouReceive": "You receive more pesos: $3,234.17 MXN",
          "YouSave": "You save (sending fee $25.00 USD): $476.90 MXN",
          "YourBenefit": "Your total benefit: $3,711.07 MXN"
        }
      },
      "Disclaimer1": "*This is an example of sending $10,000 from the U.S. to Mexico using WIRE TRANSFER as the payment method through Sendola Black, compared to standard international transfer using Bank Account.",
      "Disclaimer2": "*Example created using exchange rate information from October 11, 2024, 10:30 am CST."
    },
    "Section9": {
      "Title": "Transaction Limits Tailored to Your Needs",
      "Subtitle": "Whether you're sending payments for rent, property maintenance, or making larger investments, Sendola's service is designed to accommodate your specific requirements",
      "Disclaimer1": "*Limits based on risk assessment ",
      "Disclaimer2": "*Restrictions apply"
    },
    "Section10": {
      "ApplyTitle": "Begin the Sendola Black Experience",
      "ApplyButton": "Apply today",
      "Title": "Frequently Asked Questions",
      "Question1": {
        "Question": "How long does it take to process a transfer?",
        "Answer": "Up to 3 business days, depending on the payment method and the destination country you select."
      },
      "Question2": {
        "Question": "What are the available Payment Method options? ",
        "Answer": "You can choose Wire Transfer for same-day or next-day execution, or select one of the following options based on your convenience:",
        "Bullet1": "ACH pull - You must keep the funds in your account until you receive confirmation from Sendola.",
        "Bullet2": "Zelle - The user sends the funds to Sendola via Zelle. ",
        "Details": "For more details, see the Payment Methods, Fund Reception, and Credit Time table."
      },
      "Question3": {
        "Question": "Table of Payment Methods, Fund Reception, and Credit Time table:",
        "Answer": "See or download table"
      },
      "Question4": {
        "Question": "What countries can I send money to?",
        "Answer": "Currently, you can send money to Mexico, with more countries coming soon, including Guatemala, Canada, and Portugal."
      },
      "Question5": {
        "Question": "How secure is my transaction?",
        "Answer": "Sendola uses bank-grade encryption and compliance standards to ensure your funds are secure.<br>Our concierge team works directly with you, providing immediate assistance and updates on your transaction status, ensuring complete peace of mind from start to finish."
      }
    }
  },
  "ClaroPay": {
    "title": "¿Envías o recibes dinero <span>desde EE.UU.</span>?",
    "doItWith": "Hazlo con",
    "sendNow": "¡Envía ahora!",
    "sendMoneyNow": "¡Envía dinero ahora!",
    "knowMore": "Conoce más",
    "receiveMoney": "Recibe tu dinero en",
    "orAnyAccount": "o en cualquier cuenta bancaria de México",
    "benefitsTitle": "Beneficios de recibir dinero en Claro Pay",
    "askFor": "Pide que te envíen",
    "coupon": {
      "title": "¡Entre más envías, más ahorras!",
      "subtitle": "Usa tu cupón de bienvenida:",
      "couponName": "HOLACLAROPAY",
      "description": "Envía $100 dólares y <span>paga solo $99</span>",
      "disclaimer": "Promoción: $1 dólar de descuento por cada $100 dólares enviados. Aplica en envíos a partir de $100 dólares. Válido hasta el 31 de agosto de 2025."
    },
    "lines": {
      "line1": "Recibe <span>más pesos por tus dólares</span>",
      "line2": "Gana <span>MEGAS</span> en tu línea Telcel al recibir dinero*",
      "line3": "<span>Paga servicios</span> como luz, agua, gas e internet sin salir de casa.",
      "disclaimer": "Cada peso que recibes de EE.UU se convierte en MEGAS para el número Telcel asociado. Limitado a 4GB por usuario por mes calendario, con un límite de 2GB por operación. "
    },
    "learnMore": "Más información.",
    "requestNow": "Solicitar ahora",
    "threeSteps": "Envía dinero en 3 simples pasos:",
    "featuresCard": {
      "title": "¿Aún no tienes cuenta con Claro Pay?",
      "subtitle": "Descubre todo lo que puede hacer:",
      "feature1": "<span>Recibe dinero desde EE.UU y gana MEGAS</span> por cada envío.",
      "feature2": "<span>Recarga saldo y paga tu plan celular</span> en Telcel, Claro, Movistar, Tigo y más.",
      "feature3": "<span>Paga servicios</span> como luz, agua, gas e internet sin salir de casa.",
      "feature4": "<span>Envía y recibe dinero</span> al instante con otros usuarios de Claro Pay.",
      "feature5": "<span>Retira efectivo</span> en más de 5,000 puntos, incluyendo cajeros y corresponsales.",
      "feature6": "<span>Compra en más de 11,000 comercios</span> usando tu app."
    },
    "form": {
      "title": "Contáctanos",
      "subtitle": "Nos encantará escucharte."
    },
    "cards": {
      "card1": "Abre tu cuenta con Sendola Pay, y comienza la experiencia.",
      "card2": "Registra tus datos para poder enviar dinero a México y más destinos.",
      "card3": "Agrega beneficiarios con cuenta Claro Pay y envía dinero y <span>MEGAS</span>."
    },
    "welcomeTo": "¡Bienvenido a",
    "discover": "Descubre lo que puedes hacer!",
    "receiveInMainBanks": "Envía dinero a los <span>principales bancos y puntos de retiro de efectivo</span> en todo el país.",
    "banksAndMore": "BBVA, Banorte, Banco Azteca, BanCoppel, OXXO, Elektra, Farmacias Guadalajara, <span>¡y más!</span>",
    "signUp": "Enviar ahora",
    "mockDisclaimer": "*Los precios, comisiones, cotización y tipos de cambio son únicamente de carácter ilustrativo y están sujetos a cambios sin previo aviso.",
    "paymentMethodOptions": "<span>Fondea tu envío</span> con cualquier banco o método de pago en EE. UU., incluyendo:",
    "sendolaOpenAccount": "Abrir cuenta",

    "moneyIntoData": "Cada vez que envías dinero, quien lo recibe obtiene Megas Telcel de regalo.",
    "disclaimer": "*Aplica para envíos a cuentas Claro Pay Inbursa.",
    "promoDetails": "Para consultar más detalles sobre las promociones, <a href='{{link}}' target='_blank' rel='noopener noreferrer'>haz clic aquí</a>.",
    "mainFeatures": {
      "moreThanMoney1": "Prepárate para enviar",
      "moreThanMoney2": "que dinero"
    },
    "sendToAccountDescription": "<b>Vincula tu cuenta Claro Pay</b> o la de otra persona <b>y transfiere dinero</b> de forma fácil, rápida y ¡sin complicaciones!",
    "requestYourAccount": "Activa tu cuenta hoy mismo",
    "discoverAll": "Conoce algunos de los beneficios",
    "youCanDo": "de la cuenta Claro Pay Inbursa:",
    "openAccount": "Me interesa",
    "quoteDisclaimer": "Los precios, comisiones, cotización y tipos de cambio son únicamente de carácter ilustrativo y están sujetos a cambios sin previo aviso.",
    "claroTermsDisclaimer": "Consulta los Términos y Condiciones en la app de Claro Pay.",
    "inviteFriends": "Invita a tus amigos a disfrutar de los beneficios de",
    "invite": "Invitar",
    "apply": "Solicitar ahora",
    "features": {
      "rechargeGift": "<b>Obtén Megas de regalo</b> en recargas, paquetes y facturas Telcel.",
      "buyInStores": "Compra en Sears o Sanborns y <b>obtén 5% de dinero de vuelta</b>.",
      "sanbornsDiscount": "<b>10% de descuento</b> al pagar en restaurante <b>Sanborns</b>.",
      "starMedicaDiscount": "<b>10% de descuento</b> en Laboratorios e Imagen en <b>StarMédica</b>",
      "rechargeAccount": "<b>Recarga saldo y paga tu plan celular</b> en Telcel, Claro, Movistar, Tigo y más.",
      "payYourServices": "<b>Paga recibos</b> de <b>luz, agua, gas, internet y muchos más</b>.",
      "withdrawMoney": "<b>Retira dinero</b> en más de 5,000 lugares, incluyendo cajeros."
    }
  }
}